import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getTooltips } from '@/api/insights';
import { getSafeError } from '@/stores/insights/helpers';
import { useAppSnackbar } from '@/stores/app/snackbar';

export const useTooltips = defineStore('tooltips', () => {
  const tooltips = ref({});

  const setTooltips = (value) => {
    tooltips.value = value;
  };

  const loadTooltips = async (tooltipKeys) => {
    try {
      const newTooltips = await getTooltips(tooltipKeys);

      setTooltips(newTooltips);
    } catch (error) {
      const safeError = getSafeError(error);

      useAppSnackbar().addErrorSnackbar({
        text: `Unable to load tooltips - ${safeError}`,
      });

      throw error;
    }
  };

  return {
    tooltips,
    setTooltips,
    loadTooltips,
  };
});
